import type { RepositoryType } from '../../utils/api-client/api-schemas.ts'
import { SCMIcon } from '../third-party-branding/scm-icon.tsx'
import * as styles from './drawer-repository-context.css.ts'

type DrawerRepositoryContextProps = {
  type: RepositoryType
  name: string
}

/**
 * The repository a drawer acts on, on its own line above the drawer's title. A span so it can sit inside
 * `Dialog.Title`, which renders a heading.
 */
export const DrawerRepositoryContext: React.FC<DrawerRepositoryContextProps> = ({ type, name }) => (
  <span className={styles.repositoryContext}>
    <SCMIcon type={type} size="small" />
    {name}
  </span>
)
